import { useTranslation } from "react-i18next";
import styled from "styled-components";

import srcSpinner from "../../assets/images/blue-spinner.gif";
import { Artifact, ArtifactProjectTypeLabel } from "../../models";

const LoaderContainer = styled.div`
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

const Loader = styled.img`
  width: 100px;
  height: 100px;
  padding: 30px;
`;

const ModalHeader = styled.div`
  background: #c0c0c0;
  color: var(--primary-fg);
  font-weight: 400;
  font-size: 25px;
  padding: 15px;
  box-sizing: border-box;
  width: 100%;
`;

const Heading = styled.div`
  font-size: 25px;
  color: var(--primary-fg);
  padding: 12px 10px;
`;

const SystemName = styled.div`
  font-size: 15px;
  color: var(--primary-fg);
  padding: 0px 10px;
`;

type Props = {
  artifact: Artifact;
};

const VersionHistoryLoader = ({ artifact }: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <LoaderContainer>
      <ModalHeader>
        <Heading>{t("modal.version_history.heading")}</Heading>
        <SystemName>
          System:{" "}
          {artifact.artifactProjectType
            ? ArtifactProjectTypeLabel[artifact.artifactProjectType]
            : "-"}
        </SystemName>
      </ModalHeader>
      <Loader src={srcSpinner} alt={t("loading")} />
    </LoaderContainer>
  );
};

export default VersionHistoryLoader;
